import React from 'react';
import styled from 'styled-components';
import ReactSkeleton from 'react-loading-skeleton';
const SkeletonOverride = styled.div `
  > span {
    display: block;
    height: 0;
  }
`;
const Skeleton = (props) => {
    return (React.createElement(SkeletonOverride, null,
        React.createElement(ReactSkeleton, Object.assign({}, props))));
};
export default Skeleton;
